import React from 'react';
export const useDebounce = (value, delay) => {
    const [outValue, setOutValue] = React.useState(value);
    React.useEffect(() => {
        const handler = setTimeout(() => setOutValue(value), delay);
        return () => clearTimeout(handler);
    }, [value]);
    return outValue;
};
//# sourceMappingURL=useDebounce.js.map